export const QUICK_BUTTON_CONTAINER_BUILD_SCREEN_READER_CURRENT_ITEMS_NUMBER_KEY = '{{currentItemsNumber}}';
export var QuickButtonContainerVariantType;
(function (QuickButtonContainerVariantType) {
    QuickButtonContainerVariantType["DEFAULT"] = "DEFAULT";
})(QuickButtonContainerVariantType || (QuickButtonContainerVariantType = {}));
//# sourceMappingURL=quickButtonContainer.js.map